module.exports = __webpack_public_path__ + "img/app-qrcode.49a899d6.png";